import { Pba } from '../pba';

export class PbaTransactionsModalPayload {
  pba: Pba;
}
